<template>
  <div class="nav-btn-list">
    <a
      v-for="(btn, index) in mutableButtons"
      :key="index"
      class="nav-btn-list__btn"
      :class="btn.classes"
      :href="btn.location">
      <font-awesome-icon v-if="btn.icon"
                         :icon="btn.icon"
                         size="1x"> </font-awesome-icon>
      {{ btn.label }}
    </a>

    <b-dropdown
      id="main-nav-links"
      no-caret
      right
      class="nav-btn-list__dropdown"
      toggle-class="nav-btn-list__toggle">
      <template #button-content>
        <span class="visually-hidden">
          Navigation menu
        </span>
        <font-awesome-icon icon="bars"></font-awesome-icon>
      </template>

      <b-dropdown-item
        v-for="(link, index) in links"
        :key="index"
        :href="link.url"
        :target="link.target"
        :rel="link.target ? 'noopener' : null">
        {{ link.name }}
      </b-dropdown-item>
    </b-dropdown>

    <ul class="nav-btn-list__pages">
      <li v-for="(link, index) in links"
          :key="index">
        <a
          :href="link.url"
          :target="link.target"
          :rel="link.target ? 'noopener' : null"
          class="nav-btn-list__page">
          {{ link.name }}
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "NavigationButtonList",
  props: {
    links: {
      type: Array,
      default: () => [],
    },
    isLoggedIn: {
      type: Boolean,
      default: false,
    },
    isAdminUser: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ( {
    buttons: [
      {
        label: "All LM Resources",
        location: "/tools",
        classes: "cta cta--slim cta--monochrome--alt",
        icon: ["fal", "toolbox"],
      },
      {
        label: "Dashboard",
        location: "/",
        classes: "cta cta--slim cta--primary-no-border",
        icon: ["fal", "home"],
      },
    ],
    mutableButtons: [],
  } ),
  created () {
    if ( this.isAdminUser ) {
      this.buttons.push( {
        label: "Admin",
        location: "/admin-area",
        classes: "cta cta--slim cta--primary-no-border",
        icon: ["fal", "tools"],
      } );
    }

    this.mutableButtons = this.isLoggedIn
      ? this.buttons
      : this.buttons.map( btn => ( { ...btn, classes: "d-none" } ) );
  },
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/index.less";

.nav-btn-list {
  display: flex;
  justify-content: center;
  align-items: flex-start;

  &__btn {
    margin-right: 10px;
    color: #fff;

    &:last-child {
      margin-right: 0;
    }
  }

  @media (max-width: 1199px) {
    flex-direction: column;
    justify-content: stretch;
    width: 100%;
    padding: 0 10px;

    &__btn {
      margin-right: 0;
      margin-bottom: 10px;
      width: 100%;
    }
  }

  &__dropdown.show /deep/ .nav-btn-list__toggle {
    background: darken(@blue, 20%) !important;
    border-color: darken(@blue, 20%) !important;
  }

  &__pages {
    display: none;
  }

  &__page {
    display: block;
    padding: 8px 10px;
    text-align: center;
    font-size: 1.25rem;
    border-radius: 5px;
    background: #f3f2f1;

    &:hover {
      background: #e3e2e1;
    }
  }

  @media (max-width: 1199px) {
    &__dropdown {
      display: none;
    }

    &__pages {
      display: flex;
      width: 100%;
      flex-direction: column;
      justify-content: stretch;
      list-style-type: none;
      padding: 0;
      margin-bottom: 10px;
    }
  }

  /deep/ &__toggle {
    background: @blue;
    border-color: @blue;
    border-radius: 5px;
    padding-top: 4px;
    padding-bottom: 4px;

    &:not(:disabled):not(.disabled):active,
    &:not(:disabled):not(.disabled).active,
    &:not(:disabled):not(.disabled):focus,
    &:not(:disabled):not(.disabled):hover {
      background: darken(@blue, 20%);
      border-color: darken(@blue, 20%);
    }
  }

  /deep/ .dropdown-item:active {
    color: #fff !important;
    background: @blue;
  }

  /deep/ .dropdown-item {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}
</style>
